import { useLanguage } from '../../../features/language/useLanguage';
import { formatDateForGroup } from '../../../utils/date';
import type { SalesOrder } from '../../../types/salesOrder';
import { SalesOrderMobileCard } from './SalesOrderMobileCard';
import type { SalesOrderRowActions } from './types';

interface SalesOrderMobileListProps extends SalesOrderRowActions {
  orders: SalesOrder[];
  isEmpty: boolean;
  grouped: boolean;
  groupedOrders: Record<string, SalesOrder[]>;
  sortedDates: string[];
}

/** Mobile list of sales orders, optionally grouped by order date. */
export function SalesOrderMobileList({
  orders,
  isEmpty,
  grouped,
  groupedOrders,
  sortedDates,
  ...actions
}: SalesOrderMobileListProps) {
  const { t } = useLanguage();

  return (
    <div className="md:hidden space-y-6">
      {isEmpty ? (
        <div className="p-6 text-center text-sm text-gray-500 italic">{t('salesOrder.list.empty')}</div>
      ) : grouped ? (
        sortedDates.map((dateKey) => (
          <div key={dateKey}>
            <h3 className="text-sm font-semibold text-gray-500 mb-3 ml-1">{formatDateForGroup(dateKey)}</h3>
            <div className="space-y-4">
              {groupedOrders[dateKey].map((so) => (
                <SalesOrderMobileCard key={so.id} so={so} {...actions} />
              ))}
            </div>
          </div>
        ))
      ) : (
        orders.map((so) => <SalesOrderMobileCard key={so.id} so={so} {...actions} />)
      )}
    </div>
  );
}
